import React from 'react';
import {GameInfoModuleProps} from "../models/game-info-module.props";
import {GameInfoModuleController} from "../game-info-module.controller";
import {Compose, ComposeSettings} from "../../../../../core/components/composers/compose";
import {WidgetWrapper} from "../../../../../core/components/misc/widget-wrapper/widget-wrapper";
import {GameInfoModulePlaceholder} from "./placeholders/game-info-module.placeholder";
import {COMPONENT_STATES, FETCHING_STATES} from "../../../../../core/consts";
import {Loader, LoaderProps} from "../../../../../core/components/loading/loader";
import classnames from "classnames";
import styles from "../styles/game-info-module.module.scss";
import {GameInfoModuleItem} from "./game-info-module.item";

export class GameInfoModuleComponentProps extends GameInfoModuleProps {
}

export const GameInfoModuleComponent = ({controller}: GameInfoModuleComponentProps) => {
  const {state} = controller;
  const {device: {isSmallView}, items} = state;

  const loaderProps: LoaderProps = {
    when: state.componentState === COMPONENT_STATES.loading || state.fetchingState === FETCHING_STATES.fetching,
    Component: GameInfoModulePlaceholder
  }

  const cardWrapperProps = {
    className: classnames({[styles.small_view]: isSmallView}),
    title: controller.state.terms.INFO_GAME_MAIN,
    controller
  }

  return (
    <WidgetWrapper {...cardWrapperProps}>
      <Loader {...loaderProps}>
        <div className={classnames(styles.container)}>
          {
            items.map((item) => <GameInfoModuleItem item={item} key={item.key} controller={controller}/>)
          }
        </div>
      </Loader>
    </WidgetWrapper>
  )
}

const settings: ComposeSettings = {
  component: GameInfoModuleComponent,
  propsType: GameInfoModuleComponentProps,
  controllerType: GameInfoModuleController,

  createModule: true,
  observe: true,
}

export default Compose(settings);
